import React from 'react';
import configData from "../../config.json";
import { useHistory } from 'react-router-dom';
import { useLocation } from "react-router-dom";
function CollectionCard({ collection, cardLayout }) {
    const history = useHistory();
    const location = useLocation();
    //return (
    //    collection && (<div className="collectionDetails">
    //        <h2>{collection.name}</h2>
    //        <p>Actie {collection.endDate && new Date(collection.endDate) < new Date() ? "liep" : "loopt"} van {collection.startDate ? new Date(collection.startDate).toLocaleDateString() : ''} tot {collection.endDate ? new Date(collection.endDate).toLocaleDateString() : ''}</p>
    //        {collection.imageFile && (<p><img alt={collection.name}  style={{
    //            width: 'auto',        // breedte past zich proportioneel aan
    //            maxWidth: '100%',     // voorkomt dat hij buiten de container gaat
    //        }} src={configData.BLOB_COLLECTION_URL + collection.imageFile} /></p>)}
    //    </div> )
    //);

    return (
        collection && (
            <div className = {`collectionCard ${cardLayout}`} >

                <div className="collectionImageWrapper">
                    <div className={`statusBadge ${collection.endDate && new Date(collection.endDate) < new Date() ? 'ended' : 'active'}`}>
                        {collection.endDate && new Date(collection.endDate) < new Date() ? 'AFGELOPEN' : 'ACTIEF'}
                    </div>

                    <img
                        className="collectionImage"
                        src={configData.BLOB_COLLECTION_URL + collection.imageFile}
                        alt={collection.name}
                    />
                </div>

                <div className="collectionContent">

                    <h2 className="collectionTitle">
                        {collection.name}
                    </h2>

                    <div className="collectionProgressHeader">
                        <span className="progressPercentage">{Math.round(collection.collectedItemCount / collection.totalItemCount * 100)}% <small>compleet</small></span>
                        <span className="progressCount">{collection.collectedItemCount} / {collection.totalItemCount}</span>
                    </div>

                    <div className="progressBar">
                        <div className="progressFill" style={{
                            width: `${collection.totalItemCount > 0
                                ? Math.round(
                                    (collection.collectedItemCount / collection.totalItemCount) * 100
                                )
                                : 0
                                }%`
                        }} />
                    </div>

                    {collection.collectedItemCount < collection.totalItemCount ? (
                    <div className="missingText">
                        Nog {collection.totalItemCount - collection.collectedItemCount} missend
                    </div>) : (<div />)}

                    <div className={`buttonRow ${cardLayout}`}>
                        {cardLayout === 'vertical' ? (
                        <><button className="btn btnPrimary" onClick={() => history.push('/collection/' + collection.collectionId)}>Bekijk collectie</button>
                        <button className="btn btnSecondary" onClick={() => history.push('/trade/' + collection.collectionId)}>⇄ Ruilen</button></>) :
                            (
                                <>
                                    {!location.pathname.startsWith('/collection/') && (<button className="btn" onClick={() => history.push('/collection/' + collection.collectionId)}>Collectie</button>)}
                                    {!location.pathname.startsWith('/trade/') && (<button className="btn" onClick={() => history.push('/trade/' + collection.collectionId)}>Ruilen</button>)}
                                    {!location.pathname.startsWith('/traderequests/') && (<button className="btn" onClick={() => history.push('/traderequests/' + collection.collectionId)}>Ruil verzoeken</button>)}
                                </>
                            )}

                    </div>

                </div>

            </div>

        )
    );
}

export default CollectionCard;